import React, { useEffect } from 'react';
import Menu from './components/Menu';
import { QueryClient, QueryClientProvider } from 'react-query';
import { combineReducers } from '@reduxjs/toolkit';
import { settingsReducer, actions } from './hooks/useSettings';
import { fastdraftRelaticsSecurityReducer, actionsSecurity } from './hooks/useSecurity/useSecurityStore';
import { ConfigPageComponent, ModePage } from '../../modules/core/types/common/ConfigPageComponent';
import { useDispatch } from 'react-redux';
import * as x from '../../modules/navigation/ducks/navbar';
const queryClient = new QueryClient();

const FastDraftRelatics = (props: ConfigPageComponent) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(actions.setAppLink(props.link));
        dispatch(actions.setModePage(ModePage.BaseComponent));
        dispatch(x.setShowNavBar(props?.showHeader ?? true));
        dispatch(actionsSecurity.loadSecurity("FastDraftRelaticsSync"));
    }, [dispatch]);


    return (
        <QueryClientProvider client={queryClient}>
            <Menu />
        </QueryClientProvider>  
    );
};

export default FastDraftRelatics;

export const fastdraftRelaticsSyncLogsReducer = combineReducers({
    settings: settingsReducer,
    security: fastdraftRelaticsSecurityReducer
});
